import { EXCLUDED_SECTOR_IDS } from '@/creditflowresearch/application/Deal/constants';
import * as FILTER_TYPES from '@/creditflowresearch/application/PageFiltersState/constants';
import { insertCompanyFilters, insertIndustryFilters, insertSectorFilters } from '@/creditflowresearch/application/helpers';
import { IChartItem } from '@/creditflowresearch/infrastructure/repository/MarketChartRepository/types';

export const filterEmptyDeals = (collection: IChartItem[]): IChartItem[] => collection.map((item: IChartItem) => {
  const filterEmptyCount = item?.dealChartData
      .filter((itemPerDate) => itemPerDate.dealCount > 0);

  return { ...item, dealChartData: filterEmptyCount };
});

export const prepareChartPayload = async (payload, context, isConsumerOverview: boolean) => {
  const { query } = context;
  const {
    companyViewId,
    sector,
    industry,
    sponsorName,
  } = query;

  let { filters: filter } = payload;

  if (companyViewId) {
    try {
      const companyFilter = await insertCompanyFilters(context, filter);
      filter = { ...filter, ...companyFilter };

      if (sponsorName) {
        payload.groupBy = FILTER_TYPES.PARENT;
      }
    } catch (e) {
      return { ...payload, filters: filter };
    }
  }

  if (sector) {
    const sectorFilter = insertSectorFilters(context, filter);
    filter = { ...filter, ...sectorFilter };
  }

  if (industry) {
    const industryFilter = insertIndustryFilters(context, filter);
    filter = { ...filter, ...industryFilter };
  }

  if (isConsumerOverview) {
    filter.excludedSectorIds = EXCLUDED_SECTOR_IDS;
  }

  return { ...payload, filters: filter };
};
